import { render, staticRenderFns } from "./CovidScreeningLogs.vue?vue&type=template&id=078947c4&"
import script from "./CovidScreeningLogs.vue?vue&type=script&lang=js&"
export * from "./CovidScreeningLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports